module.exports = __webpack_public_path__ + "img/mes-scene-auto.33d44b1e.jpg";